module.exports = __webpack_public_path__ + "static/media/icon-toux.d830b0f4.png";